module.exports = __webpack_public_path__ + "img/t3_ok.2a340e83.png";